import type { DateKey } from '@arrow/game-engine';

/**
 * When the api releases a daily (the rule lives in apps/api/src/release/release.ts; this
 * is the client's copy, for deciding what's worth asking for): the daily for D is released
 * once D has begun somewhere on Earth, i.e. once the calendar date in UTC+14 has reached
 * D. Before that the api answers 404, exactly as for a day that doesn't exist.
 */
export const EARLIEST_UTC_OFFSET_HOURS = 14;

/** The latest released date at `now`: the calendar date in UTC+14. */
export function releasedThrough(now: Date): DateKey {
	return new Date(now.getTime() + EARLIEST_UTC_OFFSET_HOURS * 60 * 60 * 1000).toISOString().slice(0, 10);
}

/** Whether the daily for `date` (`YYYY-MM-DD`) is released at `now`. */
export function isReleased(date: DateKey, now: Date): boolean {
	return date <= releasedThrough(now);
}
